export const environment = {
  production: true,
  psApiBaseUrl: 'https://ps.api.opensandbox.dev',
};
